<template>
  <form-group
    class="py-3 mt-6"
    title="Senha de 4 dígitos"
  >
    <v-row justify="start">
      <v-col cols="6">
        <user-pin-chip-status
          v-model="status"
          :loading="loadingPin"
        />
      </v-col>
      <v-col
        v-if="status"
        cols="6"
      >
        <v-btn
          color="success"
          outlined
          :loading="isLoading"
          @click="unlockPin()"
        >
          Desbloquear Senha
        </v-btn>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import UsersPinRequest from 'App/users/services/UsersPinRequest';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import UserPinChipStatus from 'App/users/components/chips/UserPinChipStatus.vue';
import AnalysisTableRequest from '@/app/modules/contacard/analysisTable/AnalysisTableRequest';

export default {
  name: 'UserPinContent',
  components: { FormGroup, UserPinChipStatus },
  mixins: [ServiceMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: '',
          isPinBlocked: '',
          status: '',
          client: {
            id: '',
          },
        };
      },
    },
  },
  data: () => ({
    requestClass: UsersPinRequest,
    AnalysisTableRequest,
    loading: false,
    config: {
      successMessage: 'Sucesso ao fazer desbloqueio do PIN!',
      errorMessage: 'Falha ao fazer desbloqueio do PIN!',
    },
  }),
  computed: {
    status() {
      return this.value.isPinBlocked;
    },
    userSystemId() {
      return this.analysisTable.client.idUsuarioAdmin;
    },
    getId() {
      return this.value.client.id;
    },
    reload() {
      return this.reloadPin;
    },
    loadingPin() {
      return this.contacard.loadingPin;
    },
    isLoading() {
      return this.loading || this.loadingPin;
    },
  },
  methods: {
    unlockPin() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.unlock(
          this.userSystemId,
          this.getId,
        ),
        this.config,
        this.reloadInfo,
      );
    },
    reloadInfo(_, error) {
      this.handleLoading();
      if (!error) {
        this.reload();
      }
    },
  },
  inject: {
    reloadPin: {
      default() {
        return () => {};
      },
    },
    contacard: {
      default() {
        return {
          loadingPin: '',
        };
      },
    },
    analysisTable: {
      default() {
        return {
          client: {
            idUsuarioAdmin: '',
          },
        };
      },
    },
  },
};
</script>
